import { render, staticRenderFns } from "./CargoEditar.vue?vue&type=template&id=350989bb"
import script from "./CargoEditar.vue?vue&type=script&lang=js"
export * from "./CargoEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports